import styled from 'styled-components';

import { BaseStyle } from '@nhl/nhl-breakaway-ui';

export const PlayerContainer = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 100%;
    height: 64px;
`;

export const PlayerCompareContainer = styled.div`
    ${BaseStyle.Mixins.gaps.small}
    display: flex;
    flex-direction: column;

    ${BaseStyle.Mixins.screenSizes.medium} {
        ${BaseStyle.Mixins.gaps.semiMedium}
    }
`;

export const DetailsContainer = styled.div`
    ${BaseStyle.Mixins.gaps.medium}
    display: flex;
    align-items: center;
    justify-content: space-between;
`;

export const SmallPlayerInfoContainer = styled.div`
    display: flex;
    justify-content: space-between;
`;

export const DetailLabel = styled.div`
    ${BaseStyle.Mixins.fontStyles.ui['12m']}
    display: flex;
    justify-content: center;
    align-items: center;
    min-width: 72px;
    color: ${({ theme }) => theme.Text.secondary};

    ${BaseStyle.Mixins.screenSizes.medium} {
        ${BaseStyle.Mixins.fontStyles.ui['14m']}
        text-align: center;
    }
`;

export const StatValue = styled.div`
    ${BaseStyle.Mixins.fontStyles.ui['28b']}
    text-align: right;

    ${BaseStyle.Mixins.screenSizes.medium} {
        ${BaseStyle.Mixins.fontStyles.ui['32b']}
        text-align: center;
        width: 72px;
    }
`;
